export enum SelectionFieldType {
  NORMAL = 'NORMAL',
  TEXTBOX = 'TEXTBOX',
}
